/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SelfControlWeatherProtectionContainerDto,
  SelfControlWeatherProtectionItem
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiSelfControlWeatherProtectionContainerProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlWeatherProtectionContainerDto>(
      {url: `/api/SelfControlWeatherProtectionContainer/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSelfControlWeatherProtectionContainerProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/SelfControlWeatherProtectionContainer/${projectId}`
    ] as const;
    }


export const getGetApiSelfControlWeatherProtectionContainerProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSelfControlWeatherProtectionContainerProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>> = ({ signal }) => getApiSelfControlWeatherProtectionContainerProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSelfControlWeatherProtectionContainerProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>>
export type GetApiSelfControlWeatherProtectionContainerProjectIdQueryError = ErrorType<unknown>


export function useGetApiSelfControlWeatherProtectionContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlWeatherProtectionContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlWeatherProtectionContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSelfControlWeatherProtectionContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSelfControlWeatherProtectionContainerProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSelfControlWeatherProtectionContainerItemsId = (
    id: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlWeatherProtectionItem[]>(
      {url: `/api/SelfControlWeatherProtectionContainer/Items/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSelfControlWeatherProtectionContainerItemsIdQueryKey = (id: number,) => {
    return [
    `/api/SelfControlWeatherProtectionContainer/Items/${id}`
    ] as const;
    }


export const getGetApiSelfControlWeatherProtectionContainerItemsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSelfControlWeatherProtectionContainerItemsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>> = ({ signal }) => getApiSelfControlWeatherProtectionContainerItemsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSelfControlWeatherProtectionContainerItemsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>>
export type GetApiSelfControlWeatherProtectionContainerItemsIdQueryError = ErrorType<unknown>


export function useGetApiSelfControlWeatherProtectionContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlWeatherProtectionContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlWeatherProtectionContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSelfControlWeatherProtectionContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlWeatherProtectionContainerItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSelfControlWeatherProtectionContainerItemsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiSelfControlWeatherProtectionContainer = (
    selfControlWeatherProtectionContainerDto?: BodyType<SelfControlWeatherProtectionContainerDto>,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlWeatherProtectionContainerDto>(
      {url: `/api/SelfControlWeatherProtectionContainer`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: selfControlWeatherProtectionContainerDto, signal
    },
      );
    }




export const getPutApiSelfControlWeatherProtectionContainerMutationKey = () => ['putApiSelfControlWeatherProtectionContainer'] as const;

export const getPutApiSelfControlWeatherProtectionContainerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>, TError,PutApiSelfControlWeatherProtectionContainerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>, TError,PutApiSelfControlWeatherProtectionContainerMutationVariables, TContext> => {

const mutationKey = getPutApiSelfControlWeatherProtectionContainerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>, PutApiSelfControlWeatherProtectionContainerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiSelfControlWeatherProtectionContainer(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiSelfControlWeatherProtectionContainerMutationResult = NonNullable<Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>>
    export type PutApiSelfControlWeatherProtectionContainerMutationBody = BodyType<SelfControlWeatherProtectionContainerDto> | undefined
    export type PutApiSelfControlWeatherProtectionContainerMutationError = ErrorType<unknown>
    export type PutApiSelfControlWeatherProtectionContainerMutationVariables = {data?: BodyType<SelfControlWeatherProtectionContainerDto>}

    export const usePutApiSelfControlWeatherProtectionContainer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>, TError,PutApiSelfControlWeatherProtectionContainerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiSelfControlWeatherProtectionContainer>>,
        TError,
        PutApiSelfControlWeatherProtectionContainerMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiSelfControlWeatherProtectionContainerMutationOptions(options), queryClient);
    }
